import { IWorksheetComponent } from 'Components/Worksheets/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { MeasurementsModeSection, MeasurementsReadingsSection, MeasurementsAverageSection } from '.';

let MeasurementsSectionBase: React.FC<IWorksheetComponent> = (): JSX.Element => {
  return (
    <>
      <MeasurementsModeSection />
      <MeasurementsReadingsSection />
      <MeasurementsAverageSection />
    </>
  );
};

const MeasurementsSection = withInjectedProps(MeasurementsSectionBase);
export { MeasurementsSection };
export default MeasurementsSection;
